import { useEffect } from 'react';
import {
  getUserAttributes,
  isOptedInToEmailMarketing,
  isUserLoggedIn,
} from '@noths/polaris-client-user-configuration';
import getConfig from 'next/config';

import { NextConfig } from 'src/types';

export const useCheckUserEmailMarketingPreference = (
  callback: (payload: { loggedIn: boolean; isOptedIn: boolean }) => void,
) => {
  useEffect(() => {
    (async () => {
      if (await isUserLoggedIn()) {
        const { publicRuntimeConfig } = getConfig() as NextConfig;
        const communicationPreferencesApi = publicRuntimeConfig.hosts.communicationPreferences;
        const { email = '' } = (await getUserAttributes()) || {};
        const isOptedIn = await isOptedInToEmailMarketing(communicationPreferencesApi, email);

        callback({ loggedIn: true, isOptedIn });
      } else {
        return callback({ loggedIn: false, isOptedIn: false });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
